(ns nosco.richtext.compat
  "Redactor had no schema, so the documents generate by it are a bit wild.
   
   ProseMirror has a strict schema, which works correctly most of of the time.

   However, there are a few cases where PM will not even parse some nodes that are in
   <unexpected> positions. For example, since in our PM schema, images and iframes are
   block-type elements, and they should not appear within p or li tags, then prosemirror
   will just drop them when parsing p/li tags.
   
   So this namespace exports a preprocess functions that will preserve content.

   Since this only runs when editing content interactively, users are responsible
   to fine-tune the results (e.g. move the images around).
   
   NOTE: this will run on *all* documents. We should perhaps find a way to run it
   only on Redactor generated documents, but until then the function should be idempotent.
   ")


(defn- ensure-wrapped-with-figure 
  "Wraps a node (img, iframe) in a figure, unless it's already wrapped in one, at some point
   in the ancestor tree. PM will wrap all images and iframes in figures, but redactor might have:
   * naked images
   * naked iframes
   * iframes wrapped in divs wrapped in figures"
  [node]
  ;; we need to have a parent no matter what (real-life nodes will always have, 
  ;; but for testing convenience there might be parentless children
  (when-some [parent (.-parentElement node)]
    ;; get the closest figure ancestor (no pun intended)
    (let [parent-figure (.closest node "figure")]
      ;; if no figure ancestor exists, then wrap node in one
      (when-not parent-figure
        (let [doc (.-ownerDocument node)
              wrapper (.createElement doc "figure")]
          (.insertBefore parent wrapper node)
          (.appendChild wrapper node))))))

(defn- move-node-to-top [node]
  (let [body (-> node .-ownerDocument .-body)
        parent (.-parentElement node)
        grandparent (.-parentElement parent)]
    (when (and (some? grandparent)
               (not= body parent))
      (.insertBefore grandparent node (.-nextSibling parent))
      (recur node))))

(defn preprocess
  "Preprocess a Document, and return a new one, making sure that
   images, iframes etc are put into a place where ProseMirror can parse them."
  [doc]
  ;; first, wrap all img,iframe in a figure, if not already wrapped
  (let [children (.querySelectorAll doc "img,iframe")]
    (doseq [img children]
      (ensure-wrapped-with-figure img)))
  ;; then, make sure all figures are moved to the top-level, just after their previous parent
  (let [nested-figures (.querySelectorAll doc "figure")]
    (doseq [fig nested-figures]
      (move-node-to-top fig)))
  ;; return the new doc (this was mutated, but in the future we might return a fully new doc)
  doc)